import { formatPriceInLocale } from "@lemmonhq/orders";
import type { LemmonChartValueFormat } from "./types";

export function formatChartValue(
  value: unknown,
  format: LemmonChartValueFormat | undefined,
  currency: string,
): string {
  const n = Number(value) || 0;
  switch (format) {
    case "money":
      return formatPriceInLocale(n, true, 0, currency);
    case "percentage":
      return `${n.toFixed(1)}%`;
    case "integer":
      return Math.round(n).toLocaleString("de-CH");
    case "decimal":
    default:
      return n.toLocaleString("de-CH", { maximumFractionDigits: 2 });
  }
}

/** Same as {@link formatChartValue}, but rounds to a compact "1.2K" style for tight axis/label space. */
export function formatChartValueCompact(
  value: unknown,
  format: LemmonChartValueFormat | undefined,
  currency: string,
): string {
  const n = Number(value) || 0;
  const abs = Math.abs(n);
  if (format === "percentage") return `${n.toFixed(0)}%`;
  if (abs < 1000) return formatChartValue(value, format, currency);
  const compact = new Intl.NumberFormat("de-CH", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(n);
  return format === "money" ? `${currency} ${compact}` : compact;
}
